module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/plugin-gotenehus-mapping-data/plugin-gotenehus-mapping-data.component.scss
// module id = ./src/app/pages/plugin-gotenehus-mapping-data/plugin-gotenehus-mapping-data.component.scss
// module chunks = main